import React from 'react';

import { StyledLoaderLine } from 'components/loader-line/styles';

export const LoaderLine: React.FC = () => <StyledLoaderLine />;
